import SporeContract from "decentralized/contracts/SporeContract.js";
import AudioUnit from 'engine/audio.js';
import Tone from 'tone';
import BackendQuery from "decentralized/BackendQuery.js";
import {NewSporeCreated} from "decentralized/EthereumEvents.js"
import ipfs from 'decentralized/Ipfs.js';
const bufferToArrayBuffer = require('buffer-to-arraybuffer');

export const getAllSpores = async (tokenId) => {

   let query = new BackendQuery(new SporeContract().contractAddress)
        .from(NewSporeCreated);
    let results = await query.executeQuery();
    if (tokenId !== undefined) {
        results = results.filter(x => (x.tokenId === null && tokenId === 1) || x.tokenId === tokenId);
    }
    return results;
};

export const getLatestSpore = async (spore, tokenId) => {
    let query = new BackendQuery(new SporeContract().contractAddress)
        .from(NewSporeCreated);

    if (spore) {
        query.where("sporeId", spore.sporeId);
    }

    let results = await query.executeQuery();
    if (tokenId !== undefined) {
        results = results.filter(x => (x.tokenId === null && tokenId === 1) || x.tokenId === tokenId);
    }
    if (results.length === 0) {
        return null;
    }
    console.log("RESULTS=", results);
    let latest = results[0];

    let sporeHash = latest.sporeHash;

    let blob = await ipfs.getSound(sporeHash, 1000000);
    let audioBuffer = await Tone.Master.context.decodeAudioData(bufferToArrayBuffer(blob));
    let player = new AudioUnit(Tone.Master.context);
    player.setBuffer(audioBuffer);
    let ret = {
        audioUnit: player, 
        audioBuffer,
        ... latest
    };
    return ret; 
};
